import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import ModeButton from './ModeButton';
import {
    PARAMETERS_PATH,
    HELP_PATH,
    STATISTICS_PATH,
  } from '../../config/routes';
  import { AuthContext } from '../../contexts/AuthContext';

const TopAdminMenu = () => {

    const { isLoggedIn } = useContext(AuthContext);

  if (!isLoggedIn) {
    return;
  }

  return (
    <div id="admin-block" className="admin-message">
        <ModeButton />
        <Link to={PARAMETERS_PATH} className="btn btn-primary" style={{ padding: '0 5px', marginRight: '10px' }}>
            Paramètres
        </Link>
        <Link to={HELP_PATH} className="btn btn-primary" style={{ padding: '0 5px', marginRight: '10px' }}>
            Aide
        </Link>
        <Link to={STATISTICS_PATH} className="btn btn-primary" style={{ padding: '0 5px' }}>
            Stats
        </Link>
    </div>
)};

export default TopAdminMenu;
